import user from "./user";
import order from "./order";
import activity from "./activity";
import grade from "./grade";

export default [...user, ...order, ...activity, ...grade];
